import { ParseKeys } from 'i18next'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { MarkerComponentProps } from 'react-image-marker'
import { myPalette } from '~/shared/ui/theme'
import { Wrapper } from './styled'

type MarkerProps = MarkerComponentProps & {
  level?: ParseKeys
  isSuccess?: boolean
  isOld?: boolean
}

export function Marker({ level, isSuccess, isOld }: MarkerProps) {
  const { t } = useTranslation()
  const background = useMemo(() => {
    if (isSuccess) return myPalette.limeGreen.main
    if (isOld) return myPalette.orange['100']

    return null
  }, [isOld, isSuccess])

  const dataTestId = useMemo(() => {
    if (isSuccess) return 'success'
    if (isOld) return 'old'
    return 'new'
  }, [isOld, isSuccess])

  return (
    <Wrapper $background={background} data-testid={`marker-${dataTestId}`}>
      {level ? t(level) : '-'}
    </Wrapper>
  )
}
